<template>
  <div>
    <b-container class="py-1 pt-xl-0 pb-3" fluid>
      <b-row no-gutters>
        <b-col>
          <b-card>
            <b-container fluid class="px-5" v-if="apartments.length > 0">
              <b-row>
                <b-col cols="12">
                  <h3>
                    <small v-if="apartments.length > 1"
                      >Selecciona tu
                      {{
                        [
                          ...new Set(
                            apartments.map((apartment) =>
                              apartment.asset_type.toLowerCase()
                            )
                          ),
                        ].join(",")
                      }}</small
                    >
                  </h3>
                  <multiselect
                    v-if="apartments.length > 1"
                    :allow-empty="false"
                    class="multiselect-sm mb-4"
                    v-model="selectedApartment"
                    :options="apartments"
                    :close-on-select="true"
                    placeholder="Bien"
                    track-by="asset_id"
                    :show-labels="false"
                  >
                    <template slot="noOptions"
                      >No hay departamentos disponibles.</template
                    >
                    <template slot="singleLabel" slot-scope="props"
                      >{{ props.option.asset_type.split("_").join(" ") }}
                      {{ props.option.number }}
                      <small>{{ props.option.project_name }}</small></template
                    >
                    <template slot="option" slot-scope="props"
                      >{{ props.option.asset_type.split("_").join(" ") }}
                      {{ props.option.number }}
                      <small>{{ props.option.project_name }}</small></template
                    >
                  </multiselect>
                </b-col>
                <b-col cols="12" class="mb-5">
                  <b-card>
                    <apartments
                      :asset="selectedApartment"
                      :tab_index="tab_index"
                      :features="features"
                      :photos="photos"
                      :images="images"
                    />
                  </b-card>
                </b-col>
              </b-row>
            </b-container>
            <b-img
              v-else-if="searchedApartments"
              :src="require('@/assets/images/no-apartments.png')"
              alt="no-apartments-img"
              class="w-100"
            />
          </b-card>
        </b-col>
        <b-col cols="12" lg="3" v-if="sidebarData.length > 0">
          <sidebar :sidebar-data="sidebarData" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import apartments from "../views/apartments/Apartments";
import Sidebar from "../views/sidebar/Sidebar";
export default {
  name: "index",
  components: {
    apartments,
    Sidebar,
  },
  props: {
    customer: { default: null },
  },
  data() {
    return {
      asset_id: null,
      apartments: [],
      tab_index: 0,
      selectedApartment: null,
      sidebarData: [],
      features: [],
      photos: [],
      images: [],
      searchedApartments: false,
    };
  },
  mounted() {
    this.setApartments();
    if (this.$route.query.card_response) {
      if (this.$route.query.card_response == "true") {
        this.$swal("Éxito!", "Tarjeta Agregada con éxito", "success").then(
          () => {
            if (this.apartments.length > 1)
              this.$swal(
                "¡Debes agregar bienes a tu tarjeta!",
                "favor ve a la pestaña pagos automaticos, pincha el boton agregar bienes y señala cual quieres usar en tu tarjeta",
                "info"
              );
          }
        );
      } else {
        this.$swal(
          "Parece que hubo un error agregando tu tarjeta!",
          "",
          "info"
        );
      }
    }
  },
  methods: {
    setApartments() {
      let self = this;
      this.axios
        .get("assets/")
        .then((result) => {
          this.searchedApartments = true;
          if (result.data.assets.length > 0) {
            this.apartments = result.data.assets;
            this.$store.commit("setApartments", result.data);
            this.selectedApartment = this.apartments[0];
          } else {
            if (this.customer == "clab" && this.apartments.length == 0) {
              this.axios
                .get(`projects/1/get_amc_features`)
                .then((result) => {
                  self.sidebarData = result.data.sidebarResponse
                    ? result.data.sidebarResponse.categoriasSidebars
                    : [];
                })
                .catch((error) => {
                  console.log(error);
                  return null;
                });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  watch: {
    selectedApartment: {
      handler: function () {
        if (this.selectedApartment) {
          let self = this;
          this.axios
            .get(
              `projects/${this.selectedApartment.project_id}/get_amc_features`
            )
            .then((result) => {
              self.sidebarData = result.data.sidebarResponse
                ? result.data.sidebarResponse.categoriasSidebars
                : [];
              self.features = result.data.amcCaracteristicas
                ? result.data.amcCaracteristicas.filter((data) => data.activo)
                : [];
              self.photos = result.data.amcImagenes.filter(
                (data) => data.activo && data.tipo == "CARRUSEL"
              );
              self.images = result.data.amcImagenes.filter(
                (data) =>
                  data.activo &&
                  ["FOTO", "PRESENTACION", "PORTADA"].includes(data.tipo)
              );
            })
            .catch((error) => {
              console.log(error);
              return null;
            });
        }
      },
      immediate: true,
    },
  },
  computed: {
    project() {
      return this.selectedApartment
        ? this.$store.getters.getProjectByMoby(
            this.selectedApartment.project_id
          )
        : null;
    },
    logo() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.logo_1_url
        : null;
    },
  },
};
</script>
<style></style>
